import styled from 'styled-components'

export const DashboardWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
`
export const CsrAllocationTitleBar = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
`
